import { render, staticRenderFns } from "./distributionRules.vue?vue&type=template&id=ffee8956&scoped=true&"
import script from "./distributionRules.vue?vue&type=script&lang=js&"
export * from "./distributionRules.vue?vue&type=script&lang=js&"
import style0 from "./distributionRules.vue?vue&type=style&index=0&lang=css&"
import style1 from "./distributionRules.vue?vue&type=style&index=1&id=ffee8956&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffee8956",
  null
  
)

export default component.exports